import pickBy from 'lodash/pickBy';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { ECR_SESSION_ID, PDP, JSESSION_URL } from '../Common/CommonConstants';
import RestClient from '../RestClient/RestClient';

// params.appendQueryParams - Object: If any additional query parameters needs to be sent to eco rebates then send it with appendQueryParams key.
export const getEcoRebates = (params) => { //eslint-disable-line
    const ecrsessionIdCookie = Cookies.load(ECR_SESSION_ID);
    const config = {
        url: 'https://jcpenney.ecorebates.com/api/search/jcpenney/productRebateDetails.json',
        external: true,
        encode: false,
        options: {
            jsonpCallback: 'jsoncallback',
        },
        params: pickBy({
            skus: params.itemsWithRebates,
            uiContext: params.uiContext,
            zipcode: params.deliveryZipcode,
            previewDate: params.previewDate,
            ...params.appendQueryParams,
        }),
    };
    /* istanbul ignore next */
    if (ecrsessionIdCookie && params.uiContext === PDP) {
        config.url = config.url.concat(`${JSESSION_URL}${ecrsessionIdCookie}`);
    }
    /* istanbul ignore next */
    return RestClient.jsonp(config)
        .then((json) => {
            const {
                data: { ecrsessionid = '' },
            } = json;
            params.uiContext === PDP && Cookies.save(ECR_SESSION_ID, ecrsessionid);
            return json;
        })
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
